/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid } from '../common';

export const getPlotData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.PLOT;

  const plotData = dataSet[factKey];

  plotData.areaSource = dataSet?.baseInfo?.areaSource;
  plotData.areaSourceComment = dataSet?.baseInfo?.areaSourceComment;

  const PlotFactsRow = ({ facts }) => {
    const areaFields = ['area'];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value} <Unit areaFields={areaFields} facts={facts} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  let fields = [];

  Object.keys(plotData).forEach((fieldKey, index) => {
    if (checkIfValueIsValid(plotData[fieldKey])) {
      fields.push(
        <PlotFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: plotData[fieldKey]
          }}
        />
      );
    }
  });

  const PlotSection = () => {
    return <div className='plot-data-body'>{fields}</div>;
  };

  return {
    component: <PlotSection />,
    factsCount: fields.length
  };
};
